import React from "react";
import { Image, Video, Images, Calendar, User, MessageSquare } from "lucide-react";
import useReveal from "../hooks/useReveal";
import { BLOG } from "../mock";

const TYPE_ICON = { Image, Video, Images };

export default function Blog() {
  const ref = useReveal();

  return (
    <section id="blog" className="section-pad bg-white" ref={ref}>
      <div className="container mx-auto px-4 max-w-[1200px]">
        <div className="site-heading text-center max-w-[760px] mx-auto mb-14">
          <h4>KI & Automatisierung</h4>
          <h2>{BLOG.heading}</h2>
          <p>{BLOG.text}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {BLOG.posts.map((p, i) => {
            const TIcon = TYPE_ICON[p.type] || Image;
            return (
              <article
                key={p.title}
                className="blog-card reveal"
                style={{ transitionDelay: `${i * 0.1}s` }}
              >
                <div className="blog-thumb">
                  <img src={p.img} alt={p.title} />
                  <span className="post-type">
                    <TIcon size={18} />
                  </span>
                </div>
                <div className="p-7 pt-8">
                  <h4 className="text-[19px] font-semibold leading-snug mb-4 hover:text-[#1b6ef3] transition-colors cursor-pointer" style={{ color: "#141b34" }}>
                    {p.title}
                  </h4>
                  <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-slate-400 mb-4">
                    <span className="inline-flex items-center gap-1">
                      <Calendar size={13} /> {p.date}
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <User size={13} /> {p.author}
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <MessageSquare size={13} /> {p.comments}
                    </span>
                  </div>
                  <p className="text-[15px] text-slate-500 leading-relaxed">{p.excerpt}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
